export default __webpack_public_path__ + "static/media/logo.8d48a431.png";